import Vue from 'vue'
import App from './App.vue'
import Router from './routing'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;
let router = Router.data;

// event buss as app wide state management
// use when components need to communicate but they are siblings
export const EventBus = new Vue();

Vue.use(vuetify);

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount('#appRoot');
